<template>
    <div>
        <b-table
            :items="users"
            :fields="fields"
            :busy="loading"
            primary-key="id"
            table-class="table-va-middle"
            class="shadow-sm"
            empty-text="Nenhum usuário cadastrado."
            :responsive="true"
            :per-page="perPage"
            :current-page="currentPage"
            sort-by="last_login"
            :sort-compare="customCompare"
            fixed
            sort-desc
            show-empty
            striped
            bordered
        >
            <template v-slot:table-busy>
                <div class="text-center my-3">
                    <b-spinner class="align-middle mr-1" />
                    <span class="align-middle"> Carregando usuários... </span>
                </div>
            </template>
            <template v-slot:cell(groups)="{ item }">
                <template v-if="item.is_superuser">Administrador</template>
                <template v-else>{{ humanizeGroups(item.groups) }}</template>
            </template>
            <template v-slot:cell(first_name)="{ item }">
                {{ calcFullName(item) }}
            </template>
        </b-table>
        <b-pagination
            v-model="currentPage"
            :total-rows="users.length"
            :per-page="perPage"
            first-text="Primeira página"
            last-text="Última página"
            align="center"
            :disabled="loading"
        />
    </div>
</template>

<script>
import api from "@/modules/settings/api";
import sleep from "@/utils/sleep";
import humanizeList from "@/utils/humanizeList";
import moment from "moment";

export default {
    name: "UsersLastLoginsTable",
    data() {
        return {
            loading: false,
            currentPage: 1,
            perPage: 5,
            users: []
        };
    },
    computed: {
        fields() {
            return [
                {
                    label: "Último acesso",
                    key: "last_login",
                    tdClass: "text-center",
                    sortable: true,
                    formatter(value) {
                        if (value) {
                            return moment(value).format("DD/MM/YYYY HH:mm:ss");
                        }
                        return "Nunca acessou";
                    },
                    thStyle: {
                        width: "180px"
                    }
                },
                {
                    label: "Usuário",
                    key: "username",
                    thStyle: {
                        width: "130px"
                    },
                    sortable: true
                },
                {
                    label: "Nome",
                    key: "first_name",
                    sortable: true
                },
                {
                    label: "Permissão de acesso",
                    key: "groups",
                    sortable: true,
                    thStyle: {
                        width: "370px"
                    }
                }
            ];
        }
    },
    async created() {
        this.loading = true;
        await this.$nextTick();

        await sleep(1000);
        const { data } = await api.users.lastLoginsList();

        this.users = data;
        this.loading = false;
    },
    methods: {
        humanizeGroups: humanizeList,
        calcFullName({ first_name: firstName, last_name: lastName }) {
            return `${firstName} ${lastName}`;
        },
        customCompare(a, b, key) {
            if (key !== "last_login") {
                return false;
            }

            if (!a.last_login) {
                return -1;
            }

            if (!b.last_login) {
                return 1;
            }

            const epochA = moment(a.last_login);
            const epochB = moment(b.last_login);

            return epochA.isBefore(epochB)
                ? -1
                : epochA.isAfter(epochB)
                ? 1
                : 0;
        }
    }
};
</script>
